import '@limepayments/cosmic/build/css/reset.css';
import '@limepayments/cosmic/build/css/styles.css';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import { initSentry } from 'lib/sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'redux/store';
import ResizeObserver from 'resize-observer-polyfill';

import * as Sentry from '@sentry/react';

import App from './App';

initSentry();

// polyfills
window.ResizeObserver = window.ResizeObserver || ResizeObserver;

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
